import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import formatNumber from "../_utils/formatNumber";
import { Direction } from "../_app/types";
import BadgeDirection from "./BadgeDirection";
import Text from "./Text";
import IconComponent from "./IconComponent";

interface Props {
  minPrice: number;
  maxPrice: number;
  quote: string;
  gridDirection: Direction;
  orderStep: number;
}

const PriceRange = ({ minPrice, maxPrice, quote, gridDirection, orderStep }: Props) => {
  const theme = useTheme();

  return (
    <Stack
      direction={"column"}
      spacing={1}
      sx={{ marginTop: "8px", marginBottom: "10px !important" }}
    >
      <Stack
        sx={{ width: "100%" }}
        direction={"row"}
        justifyContent={"center"}
        alignItems={"center"}
        spacing={0}
      >
        <Text variant="s">{`${formatNumber(minPrice, orderStep)}\u00A0`}</Text>
        <Text variant="s" color={theme.myTheme.colors.foreground50}>
          {quote}
        </Text>

        <Stack
          sx={{ width: "100%" }}
          direction={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <BadgeDirection gridDirection={gridDirection} />
          <Stack
            direction={"row"}
            sx={{
              width: "100%",
              opacity: ".5",
              padding: "0px 10px",
              height: "8px",
            }}
            alignItems={"center"}
          >
            <Box
              sx={{
                rotate: "90deg",
                position: "relative",
                left: -3,
                top: -9,
                width: 0,
              }}
            >
              <IconComponent
                iconName={"arrow-triangle"}
                size={18}
                customColor={theme.myTheme.colors.foreground50}
              />
            </Box>
            <Box
              sx={{
                width: "100%",
                height: "1px",
                opacity: ".5",
                display: "flex",
                justifyContent: "center",
                position: "relative",
                backgroundColor: theme.myTheme.colors.foreground50,
              }}
            />
            <Box
              sx={{
                rotate: "-90deg",
                position: "relative",
                left: 3,
                top: 9,
                width: 0,
              }}
            >
              <IconComponent
                iconName={"arrow-triangle"}
                size={18}
                customColor={theme.myTheme.colors.foreground50}
              />
            </Box>
          </Stack>
        </Stack>

        <Text variant="s"> {`${formatNumber(maxPrice, orderStep)}\u00A0`}</Text>
        <Text variant="s" color={theme.myTheme.colors.foreground50}>
          {quote}
        </Text>
      </Stack>
    </Stack>
  );
};

export default PriceRange;
